import React from "react";

// Legal links may point at an external mid-domain (domain replacer); open
// those in a new tab while keeping same-host links in the current one.
const opensInNewTab = (url) => {
  try {
    return new URL(url, window.location.href).host !== window.location.host;
  } catch {
    return false;
  }
};

const SimpleFooter = () => {
  const footerLinks = window.post_template.checkout_v4_footer.footer_links;
  const isEnhancedContrast = window.enhancedContrast;
  const showDisclaimer = window.post_template.checkout_v4_footer.footer_show_disclaimer;
  const disclaimerText = window.post_template.checkout_v4_footer.tr_footer_disclaimer_text;

  return (
    <div className={`simpleFooter ${isEnhancedContrast && "enhancedContrast"}`}>
      <div className="simpleFooter_links">
        {Array.isArray(footerLinks) &&
          footerLinks.map((link, index) => {
            const href = !link.footer_link_type
              ? link.footer_custom_link.footer_custom_link_href
              : link.footer_post_link.footer_post_link_href;
            return (
              <a
                key={index}
                href={href}
                {...(opensInNewTab(href) ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                className={`${isEnhancedContrast && "enhancedContrast"}`}
              >
                {!link.footer_link_type
                  ? link.footer_custom_link.tr_footer_custom_link_label
                  : link.footer_post_link.tr_footer_post_link_label}
              </a>
            );
          })}
      </div>
      {showDisclaimer && <div className="disclaimerText">{disclaimerText}</div>}
    </div>
  );
};

export default SimpleFooter;
